<template>
  <ul class="chapters">
    <li v-for="chapter in chapters" :key="chapter.chapterNumber">
      <router-link :data-active="activeChapter !== undefined && chapter.chapterNumber === activeChapter.chapterNumber" :to="{name: 'Page', params: { pageNumber: chapter.startPage }}">
          <div class="number">{{ chapter.chapterNumber }}</div> {{ chapter.name }}
        </router-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      chapters: 'chapters'
    }),
    activeChapter () {
      return this.chapters.find(c => c.startPage <= this.pageNumber && (!c.endPage || c.endPage >= this.pageNumber))
    },
    pageNumber () {
      return this.$route.params.pageNumber
    }
  }
}
</script>

<style lang="scss">
  @import "../../style/variables";
  .chapters {
    list-style-type: none;
    font-size: 16px;
    li {
      font-weight: bold;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      margin-bottom: 1.0em;

      &:last-child {
        margin-bottom: 0;
      }
      a {
        text-decoration: none;
        color: inherit;
        .number {
          color: #999;
          width: 20px;
          text-align: right;
          display: inline-block;
          margin-right: 10px;
        }
      }

      a[data-active="true"] {
        color: darken($lightgreen, 15);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/chapter/ChapterList.vue